// import { SwapWidget, darkTheme, Theme } from '@uniswap/widgets'
import { SwapWidget, RouterPreference, TradeType, Field, SupportedChainId } from '@uniswap/widgets/dist/index.js'
import { Token } from '@uniswap/sdk-core'

import '@uniswap/widgets/dist/fonts.css'

import { ethers } from 'ethers';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { createProvider, Eip1193, jsonRpcUrlMap, networkToChainId } from "../../constants/EIP1193";
import back from '../../styles/assets/back_arrow.svg';
import styled from 'styled-components';
import { useNavigate } from "react-router-dom";
import { registerToken, sendTXConfirmationToDevices, TXDescriptionEnum, TXNamesEnum } from '../../services/backendHelpers';
import { removeSubscribeBack, subscribeBack } from '../../services/androidCallback';
import { eventTracker } from '../../services/eventTracker';

function getByValue(map: any, searchValue: any) {
    for (let [key, value] of map.entries()) {
        if (value === searchValue)
            return key;
    }
}

// const myDarkTheme: Theme = {
//     ...darkTheme, // Extend the darkTheme
//     borderRadius: 0,
//     primary: '#FFFFFF',
//     secondary: '#7A7F9E',
//     interactive: '#26283E',
//     container: '#0E0F18',
//     module: '#171829',
//     accent: '#3999F9',
//     outline: '#171829',
//     dialog: '#0E0F18',
//     success: '#4BB34B',
//     error: '#FF6060',
// }

const SeedPhraseTitle = styled.div`
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #FFFFFF;
`;

const UNISWAP_TOKEN_LIST = 'https://xtremeverse.s3.ap-south-1.amazonaws.com/tokens.uniswap.org'

/* A React component that is used to swap tokens. */
const SwapTokens = (props: any) => {

    const [showSwap, setShowSwap] = useState(false);
    const location: any = useLocation();
    const [token, setToken] = useState(location.state);
    const [tokenList, setTokenList] = useState(null);
    const [registerTokenData, setRegisterTokenData] = useState({chainId: null, address: null});
    const [swapValue, setSwapValue] = useState<any>(null);
    const navigate: any = useNavigate();

    useEffect(() => {
        // register backpress
        subscribeBack();
        (window as any).callbackBackPressed  = () => {
            // unregister the callback
            goBack();
        };
    }, [])

    const goBack = () => {
        removeSubscribeBack();
        navigate(-1);
    };

    async function fetchAndAddToken(){
        try {
            const response = await fetch('https://xtremeverse.s3.ap-south-1.amazonaws.com/tokens.uniswap.org');
            const data = await response.json();
            // Adding btx token
            const newItem = {
                "name": "BTX Coin",
                "address": "0xF0075b06b4229C20B7c22b7E63D90723b3551861",
                "symbol": "BTX",
                "decimals": 18,
                "chainId": 137,
                "logoURI": "https://cdn-m.namasteapis.com/crypto/glip/btx.png"
            };
            // let newItemRonin = {
            //     "name": "BTX Coin (Ronin)",
            //     "address": "0x777BaEb8bDaD0E95ea94E3a4Bcc6cC2938763725",
            //     "symbol": "BTX",
            //     "decimals": 18,
            //     "chainId": 2020,
            //     "logoURI": "https://cdn-m.namasteapis.com/crypto/glip/btx.png"
            // };
            data.tokens.push(newItem);
            // data.tokens.push(newItemRonin);
            console.log(data);
            return data.tokens;
        } catch (error) {
            console.error('An error occurred:', error);
            return null;
        }
        
    }

    const getTokenList = async ()=>{
        let tokenListTemp = await fetchAndAddToken();
        setTokenList(tokenListTemp);
        return tokenListTemp
    }
    
    useEffect(() => {    
       setupSwap();
    }, []);

    const {signer, provider, prov}: any = createProvider(token.chain);
    const setupSwap = async () => {
        (window as any).Browser = {
            T: () => {}
            }

        const tokenList = await getTokenList();
        //@ts-ignore
        window.ethereum = provider;
        //@ts-ignore
        window.ronin = {provider: provider, roninEvent: provider};

        let btx = new Token(137, '0xF0075b06b4229C20B7c22b7E63D90723b3551861', 18, 'BTX', 'BTX Coin')
        let usdc = new Token(137, '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359', 6, 'USDC', 'USD Coin');  

        setSwapValue({
            type: TradeType.EXACT_INPUT,
            amount: "100",
            [Field.INPUT]: btx,
            [Field.OUTPUT]: usdc,
        })

        setShowSwap(true);
    }

    let swapSettings = {
        slippage: {
            auto: true,
            max: undefined
        },
        transactionTtl: 30,
        routerPreference: RouterPreference.API
    }

    const registerTokenForUser = () => {
        registerToken(getByValue(networkToChainId, registerTokenData.chainId), registerTokenData.address)
    }

    const sendSwapConfirmationToDevices = (txHash: string, txImage: string = "") => {
        sendTXConfirmationToDevices(TXNamesEnum.SwapTransactionSuccess, TXDescriptionEnum.SwapTransactionSuccess, registerTokenData.chainId, txHash, txImage);
    }

    if(!tokenList){
        return (<></>)
    }


    console.log('token.contractAddress', token.contractAddress, token);
    return (
        <div className="Uniswap" style={{flexDirection:'column', background: 'rgb(15,15,15)', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%'}}>
          <div onClick={() => goBack()} style={{position: 'absolute', top: 0, left: 20}}>
            <img style={{position: 'absolute', top: 20}} src={back} alt='back arrow' className='hover'/>
            <SeedPhraseTitle className='hover' style={{display: 'flex', justifyContent: 'center', marginTop: 16, marginLeft: 30}}>
              Swap
            </SeedPhraseTitle>        
          </div>
                       {/* { showSwap && <iframe style={{width: '100%', height: '100%'}}src='https://app.uniswap.org' />} */}

          {showSwap &&  token.chain != 'ronin' && <SwapWidget
                                                      hideConnectionUI={true}
                                                      width={'100%'}
                                                      jsonRpcUrlMap={jsonRpcUrlMap} 
                                                      permit2={true}
                                                    //   value={swapValue}
                                                      settings={swapSettings}
                                                        routerUrl={'https://be.namasteapis.com/blockchain/v1/glip/proxy/uniswap/'}
                                                      defaultInputTokenAddress={token.contractAddress === '0x' ? 'NATIVE' : token.contractAddress}
                                                    //   defaultOutputTokenAddress={"0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359"}
                                                      tokenList={tokenList}
                                                      onTxSuccess={(txHash, data) => {
                                                          console.log(data, txHash, 'sawp success callback');
                                                          registerTokenForUser();
                                                          sendSwapConfirmationToDevices(txHash);
                                                          eventTracker('swap_success', {            
                                                              token: token,
                                                          })
                                                      }}
                                                      defaultInputAmount={100}
                                                      onSwapSend={(trade, swapTx) => {
                                                        console.log('on swap send', trade)
                                                        setRegisterTokenData({
                                                            //@ts-ignore
                                                            chainId: trade.trade.routes[0].output.chainId,
                                                            //@ts-ignore
                                                            address: trade.trade.routes[0].output.isNative ? '0x' : trade.trade.routes[0].output.address
                                                        });
                                                      }}
                                                      onTxSubmit={(txHash, data) => {
                                                          console.log(data, txHash, 'on swap tx submit');
                                                          
                                                      }}        
          // routerUrl='https://wqbz12i5ic.execute-api.ap-south-1.amazonaws.com/prod/'
          />}
          {showSwap && token.chain === 'ronin' && 
           <>
             <span style={{color: '#fff'}}>SLP swap not setup yet</span>
             {/* <iframe src='https://katana.roninchain.com/#/swap' /> */}
           </>
          } 
        </div>
    );
}

export default SwapTokens;
